import { createScreenStyles } from '../../theme/styles';
import React, { useState, useEffect } from "react";
import {
  View,
  ScrollView,
  StyleSheet,
  Image,
  Dimensions,
  Platform
} from "react-native";

const screenWidth = Math.round(Dimensions.get("window").width);
const screenHeight = Math.round(Dimensions.get("window").height);

export function isIphoneX() {
  return Platform.OS === "ios" && screenHeight >= 812;
}

export function isAndroid() {
  return Platform.OS !== "ios";
}

export default function despesa_item({ route, navigation }) {
  
  var foto = route.params.foto;
  
  return (
    <ScrollView style={styles.containerGeral}>
      

    {foto &&  
      <View style={styles.sideContainer2}>
        <Image style={styles.tinyLogo} source={{ uri: foto }} />
      </View>
  }
    </ScrollView>
  );
}

var styles = createScreenStyles({
  container: {
    flex: 1,
    backgroundColor: "#e5e5e5",
  },

  LoadingIndicator: {
    flex: 1,
    justifyContent: "center",
    marginTop: 15,
  },

  sideContainer: {
    flexDirection: "row",
  },

  tinyLogo: {
    height: screenHeight * 0.60,
    width: '90%',
    borderRadius:10,
  },

  sideContainer2: {
    marginTop: 80,
  },

  ItemImg: {
    backgroundColor: "#fff",
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 4,
    marginLeft: screenWidth * 0.025,
    marginRight: screenWidth * 0.025,
  },

  menuItem: {
    width: '44%',
    height: screenHeight * 0.1,
    marginTop: 10,
    marginRight: 20,
    backgroundColor: "#296D98",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemG: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "green",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemY: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "#CC6600",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  menuItemR: {
    width: '94%',
    height: screenHeight * 0.06,
    marginTop: 10,
    backgroundColor: "red",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  textMenu: {
    color: "#fff",
    fontSize: 16,
  },

  textSearch: {
    width: '94%',
    paddingLeft: 10,
    color: "#484848",
    height: 50,
    marginTop: screenHeight * 0.01,
    backgroundColor: "#fff",
    borderColor: "#A1A1A1",
    borderWidth: 1,
    borderRadius: 5,
  },

  textEmpty: {
    fontSize: 14,
    fontWeight: "300",
    color: "#484848",
    marginLeft: screenWidth * 0.025,
    marginTop: 10,
    textAlign: "center",
  },

  textDesc: {
    fontSize: 14,
    paddingTop: 5,
  },

  textDescBold: {
    fontSize: 14,
    paddingTop: 5,
    fontWeight: "bold",
  },

  textDescBold2: {
    fontSize: 16,
    marginBottom: 10,
    marginTop: 10,
    fontWeight: "bold",
    textAlign: "center",
  },

  textDescAberto: {
    fontSize: 12,
    paddingTop: 5,
    color: "green",
  },

  containerGeral: {
    marginLeft: 20,
    marginRight: 20,
    paddingBottom: 10,
    borderRadius: 3,
  },

  txtContainer: {
    width: '95%',
    marginTop: 5,
  },

  highlight: {
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
  },

  buttonDone: {
    backgroundColor: "#336633",
    marginTop: 5,
    height: 30,
    width: '90%',
    justifyContent: "center",
  },

  buttonPend: {
    backgroundColor: "#993333",
    marginTop: 5,
    height: 30,
    width: '90%',
    justifyContent: "center",
  },

  buttonText: {
    textAlign: "center",
    color: "#fff",
  },
});
